import { DxDataGridOperator } from 'src/app/operators/dx-data-grid.operator';
import {SelectionSet} from './../../settings.service';
import {SelectionSetRendererComponent} from './../selection-set-renderer/selection-set-renderer.component';
import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';

@Component({
    selector: 'app-selection-options-renderer',
    templateUrl: './selection-options-renderer.component.html',
    styleUrls: ['./selection-options-renderer.component.scss'],
    standalone: false
})
export class SelectionOptionsRendererComponent implements OnInit {
	@Input()
	public selectionSets: SelectionSet[];

	@ViewChild('selectionSetRenderer', {static: false})
	public selectionSetRenderer: SelectionSetRendererComponent;

	@Output()
	public selectedSelectionSetChange: EventEmitter<SelectionSet> = new EventEmitter<SelectionSet>();

	private _selectedSelectionSet: SelectionSet;
	public get selectedSelectionSet(): SelectionSet {
		return this._selectedSelectionSet;
	}
	@Input()
	public set selectedSelectionSet(value: SelectionSet) {
		this._selectedSelectionSet = value;

		if (this._selectedSelectionSet && this.selectionSetRenderer) {
			this.selectionSetRenderer.initialize();
		}

		this.selectedSelectionSetChange.emit(this._selectedSelectionSet);
	}

	// public expanded: boolean;

	public onRowClick(evt: any): void {
		if (evt.rowType === 'data') {
			this.selectedSelectionSet = <SelectionSet>evt.data;
		}
	}

	public onRowDblClick(evt: any): void {}

	public onRowInserted(evt: any): void {}

	public onRowRemoved(evt: any): void {}

	public onRowUpdated(evt: any): void {}

	public dxDataGridOperator: DxDataGridOperator = new DxDataGridOperator();

	public onDataGridContentReady(evt) {
		this.dxDataGridOperator.updateRowCount(evt.component, true);
	}

	constructor() {}

	ngOnInit(): void {}
}
